import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { Directory } from './directory';
import { DirectoryService } from './directory.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal, NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { Toast, ToastrService } from 'ngx-toastr';
import { sub } from 'date-fns';

@Component({
  selector: 'app-directory-image',
  templateUrl: './directory-image.component.html',
  styleUrls: ['./directory-image.component.css']
})
export class DirectoryImageComponent implements OnInit {
  directories: Directory[] = [];
  allDirectories: Directory[] = [];

  constructor(private directoryService: DirectoryService, private modal: NgbModal, private toast: ToastrService) { }

  @Output()
  onAllDrectories = new EventEmitter<Directory[]>();

  @Output()
  onSelected = new EventEmitter<Directory>();

  dirSelected: Directory = null;
  contextMenuVisible = false;
  contextMenuPosition = { x: 0, y: 0 };
  contextMenuDirectory: any;


  ngOnInit() {
    this.directoryService.getDirectories().subscribe(
      (response) => {
        const data = response.data as Directory[];
        this.directories = this.directoryService.buildDirectoryTree(data);
        this.allDirectories = data;
        this.onAllDrectories.emit(data);
      },
      (error) => {
        // Manejar el caso de error
        console.error('Error al recuperar directorios', error);
      }
    );

  }
  editedValue = '';

  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    tag: new UntypedFormControl(),
    directory_id: new UntypedFormControl(),
  });

  create() {
    var tag: string = this.form.get('tag')?.value;
    if (tag.length <= 2) {
      this.toast.warning("Ingrese un nombre valido");
      return;
    }
    this.directoryService.addDirectory(this.form).subscribe(
      (newDir) => {
        // Manejar la adición exitosa del directorio
        // Por ejemplo, podrías refrescar la lista de directorios:
        this.getDirectories();
        this.form.reset();
        this.modal.dismissAll();
      },
      (error) => {
        // Manejar cualquier error
        console.error('Error al agregar directorio', error);
      }
    );

  }
  update() {
    var tag: string = this.form.get('tag')?.value;
    if (tag.length <= 2) {
      this.toast.warning("Ingrese un nombre valido");
      return;
    }
    this.directoryService.updateDirectory(this.form).subscribe(
      (newDir) => {
        this.getDirectories();
        this.form.reset();
      },
      (e) => {
        // Manejar cualquier error
        this.toast.warning(e.error.mistakes, e.error.msg);
        this.getDirectories();
      }
    );

  }

  getDirectories() {
    this.directoryService.getDirectories().subscribe(
      (response) => {
        const data = response.data as Directory[];
        this.directories = this.directoryService.buildDirectoryTree(data);
        this.allDirectories = data;
        this.onAllDrectories.emit(data);
      },
      (error) => {
        // Manejar el caso de error
        console.error('Error al recuperar directorios', error);
        this.directories=[];
        this.allDirectories=[];
        this.onAllDrectories.emit([{id:0,tag:'Raíz'}]);
      }
    );
  }
  openModalAdd(md: any, directory: Directory, size: string = 'sm') {
    console.log("Add:", directory);
    if (directory != null) {
      this.form.get('directory_id')?.setValue(directory.id);
    }
    this.modal.open(md, { size: size });
  }
  openModalDel(md: any, directory: Directory, size: string = 'sm') {
    if (directory != null) {
      this.form.patchValue(directory);
    }
    this.modal.open(md, { size: size });
  }

  enableEditMode(subdirectory: any) {
    this.editedValue = subdirectory.tag;
    subdirectory.isEditing = true;
  }


  onEnter(subdirectory: any, event: any) {
    if (event.keyCode === 13) {
      console.log("Enter", event.keyCode);
      this.directoryService.updateDirectory(this.form);
    }
  }

  disableEditMode(subdirectory: any) {
    subdirectory.isEditing = false;
    this.form.patchValue(subdirectory);
    this.update();
    this.form.reset();
    this.directoryService.updateDirectory(this.form);
  }
  deleteDirectory() {
    this.directoryService.deleteDirectory(this.form).subscribe((rs) => {
      this.toast.success("Directorio eliminado correctamente");
      this.getDirectories();
      this.modal.dismissAll();
      this.form.reset();
    }, e => {
      this.toast.warning(e.error.mistakes, e.error.msg); 
      this.selected(null);
      this.getDirectories();
     
    });

  }



  countSubDir(directory: Directory): number {
    let count: number = 0;
    if (directory.subdirectories && directory.subdirectories.length > 0) {
      for (const subdirectory of directory.subdirectories) {
        count += 1 + this.countSubDir(subdirectory);
      }
    }
    return count;
  }
 
  toggleList(directory: Directory) {
    console.log("OPEN", directory.open);
    directory.open = !directory.open;
  }


  onRightClick(event: MouseEvent, directory: any) {
    console.log("Context menu", event);
    console.log("Context directory", directory);
    event.preventDefault();
    this.contextMenuPosition = { x: event.clientX, y: event.clientY };
    this.contextMenuDirectory = directory;
    this.contextMenuVisible = true;
  }

  openContextMenu(event: MouseEvent, directory: any) {
    event.preventDefault();
    this.contextMenuPosition = { x: event.clientX, y: event.clientY };
    this.contextMenuDirectory = directory;
    this.contextMenuVisible = true;
  }
  selected(directory: Directory) {
    if (directory == null) {
      directory = { id: 0, tag: '' };
    }
    this.dirSelected = directory;
    this.onSelected.emit(directory);
  }
  getIconClass(directory: any): string {
    return this.dirSelected === directory ? 'fa-solid fa-folder-open text-warning' : 'fa-solid fa-folder';
  }
}